module.exports = __webpack_public_path__ + "static/media/3.20a249ea.jpg";